import { useState, useEffect } from 'react';
import axios from 'axios';
import SEO from './SEO';
import API_BASE_URL from '../config';
import { useTranslation } from 'react-i18next';

export type UserInfoType = {
  bio: string;
};

const Home = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [data, setData] = useState<UserInfoType>();
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const configuration = {
          url: API_BASE_URL + '/user/bio',
          method: 'get',
        }

        axios.request<UserInfoType>(configuration).then(
          (res) => {
            setData(res.data)
          }
          ).catch((err) => {
        });

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount
  return (
    <div className="font-poppins container mx-auto px-4 lg:px-12">
      <SEO
        title="AnittaMendezFitness: Ejercicios,Rutinas,Circuitos,Salud,Bienestar"
        description="Descubre cómo mejorar tu salud con circuitos y rutinas de ejercicio y motivación para lograr tus objetivos de fitness."
        image="https://anittamendezfitness.com/static/media/logo-fitness.e7fde95318d7ca1fc76f.png"
        url="https://anittamendezfitness.com/home"
      />
      <div className="relative isolate pt-14">
        <div className="flex flex-col lg:flex-row items-center gap-8">
          {/* Texto */}
          <div className="w-full lg:w-1/2">
            <div className="hidden sm:mb-8 sm:flex sm:justify-center">
              <div className="relative rounded-full px-3 py-1 text-sm leading-6 text-gray-600 ring-1 ring-gray-900/10 hover:ring-gray-900/20">
                {t('home.discover_inspiration')}{' '}
                <a href="published-articles" className="font-semibold text-indigo-600">
                  <span className="absolute inset-0" aria-hidden="true" />
                  {t('home.read_more')} <span aria-hidden="true">&rarr;</span>
                </a>
              </div>
            </div>
            <div className="text-center lg:text-left">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900">
              {t('home.activate_your_life')}
              </h1>
              <p className="mt-6 text-base sm:text-lg lg:text-xl leading-8 text-gray-600">
                {t('home.start')}
              </p>
              <div className="mt-6 flex flex-col sm:flex-row sm:justify-center lg:justify-start gap-4">
              <div className="flex justify-center">
              <a
                href="/published-articles"
                className="inline-block rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-indigo-600"
              >
                {t('home.begin')}
              </a>
            </div>
            <a href="/about" className="text-sm font-semibold leading-6 text-gray-900">
              {t('home.learn_more')} <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </div>

      {/* Imagen */}
      <div className="w-full lg:w-1/2 flex justify-center">
        <img
          src={require("../assets/images/home_1.webp")}
          alt=""
          className="rounded-md w-full max-w-md object-contain"
        />
      </div>
    </div>

    {/* Fondo decorativo */}
    <div
      className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
      aria-hidden="true"
    >
      <div
        className="relative left-1/2 aspect-[1155/678] w-[36rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff809e] to-[#277cd1] opacity-30 sm:w-[72rem]"
        style={{
          clipPath:
            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
        }}
      />
      </div>
    </div>
  </div>
  )
}

export default Home
